import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="bg-[var(--ink)] text-[#8c8882] py-12">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="flex items-center gap-2.5">
        <Logo className="h-8 w-auto" variant="light" />
        <span className="font-serif-d font-semibold text-[#faf8f5]">PILATES FACTORY<span className="text-[var(--terra)]">.</span></span>
      </div>
      <p className="text-xs">© 2024 Pilates Factory · High-end reformerek megfizethető áron</p>
      <div className="flex items-center gap-6">
        <Link to="/adatkezeles" data-testid="footer-privacy-link" className="eyebrow hover:text-[var(--terra)] transition-colors">
          Adatkezelési tájékoztató
        </Link>
        <Link to="/aszf" data-testid="footer-terms-link" className="eyebrow hover:text-[var(--terra)] transition-colors">
          ÁSZF
        </Link>
      </div>
    </div>
  </footer>
);
